<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
      
      a-form-model-item(label="产品名称" prop="name" )
        a-input(v-model="model.name" allow-clear :max-length="30" placeholder="请输入产品名称")
      a-form-model-item(label="产品类别" prop="categoryId" )
        app-tree-select(v-model="model.categoryId" api="/prj/categories/all-graph" treeDefaultExpandAll :params="params" allow-clear placeholder="请选择产品类别"
          @change="handleCategoryChange"
        )
      
      a-form-model-item(label="产品品牌" prop="brandId" )
        app-remote-select(v-model="model.brandId"  
          api="/prj/vendor-brand-mappings/list" 
          :params="params" 
          allow-clear placeholder="请选择产品品牌"
          @change="handleBrandChange"
          showSearch
        )
      a-form-model-item(label="分件数(件)" prop="parts" )
        a-input-number(v-model="model.parts" allow-clear :min="1" placeholder="请输入产品分件数")
        
      a-form-model-item(label="数量" prop="quantity" )
        a-input-number(v-model="model.quantity" allow-clear :min="1" placeholder="请输入产品数量")
      a-form-model-item(label="备注" prop="productComments" )
        a-textarea(v-model="model.productComments" allow-clear :max-length="30" placeholder="请输入备注")
        
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'CustomProduct',
  props: {
    target: Object,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加产品',
      model: {
        name: null,
        categoryId: null,
        brandId: null,
        model: null,
        specification: null,
        parts: 1,
        quantity: 1,
        productComments: '',
      },
      rules: {
        name: [{ required: true, message: '必填项' }],
        parts: [{ required: true, message: '必填项' }],
        quantity: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
        vendorId: this.target.vendorId,
      };
    },
  },
  mounted() {},
  methods: {
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        ...model,
      };
      this.action = action;
      this.title = model === undefined ? '添加产品' : '编辑产品';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        name: null,
        categoryId: null,
        brandId: null,
        model: null,
        specification: null,
        parts: 1,
        quantity: 1,
        productComments: '',
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.$emit('modal-success', { ...this.model });
        this.hide();
      }
    },
    handleCategoryChange(val, categoryNames) {
      this.model.categoryName = categoryNames[0] || null;
    },
    handleBrandChange(val, option) {
      const brand = option?.data?.attrs?.data;
      this.model.brandName = brand?.name;
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
